import React from "react";
import {
  MdWifi,
  MdAllInclusive,
  MdDns,
  MdRssFeed,
  MdBedtime,
  MdLiveTv,
  MdCardGiftcard,
  MdElectricalServices,
  MdSpeed,
  MdRouter,
  MdTv,
  MdPhoneInTalk,
  MdSms,
  MdPublic,
  MdSecurity,
  MdShield,
  MdSupportAgent,
  MdSchedule,
  MdBolt,
  MdCloud,
  MdVideocam,
  MdChildCare,
  MdSportsSoccer,
  MdMovie,
  MdMusicNote,
  MdDownload,
  MdUpload,
  MdCheckCircle,
  MdStar,
} from "react-icons/md";

/*
  Иконки характеристик тарифа. Имя приходит из админки строкой — теми же
  словами, что у Material Symbols, потому что раньше оно подставлялось
  в лигатурный шрифт. Шрифт убран (4 МБ с Google ради нескольких глифов),
  рисуем svg из react-icons по этому же имени.
*/
const REGISTRY = {
  // есть в текущих тарифах
  wifi: MdWifi,
  all_inclusive: MdAllInclusive,
  dns: MdDns,
  rss_feed: MdRssFeed,
  bedtime: MdBedtime,
  live_tv: MdLiveTv,
  card_giftcard: MdCardGiftcard,
  electrical_services: MdElectricalServices,
  // запас под будущие тарифы
  speed: MdSpeed,
  router: MdRouter,
  tv: MdTv,
  phone_in_talk: MdPhoneInTalk,
  sms: MdSms,
  public: MdPublic,
  security: MdSecurity,
  shield: MdShield,
  support_agent: MdSupportAgent,
  schedule: MdSchedule,
  bolt: MdBolt,
  cloud: MdCloud,
  videocam: MdVideocam,
  child_care: MdChildCare,
  sports_soccer: MdSportsSoccer,
  movie: MdMovie,
  music_note: MdMusicNote,
  download: MdDownload,
  upload: MdUpload,
  check_circle: MdCheckCircle,
  star: MdStar,
};

// Чтобы не засорять консоль: про каждое неизвестное имя сообщаем один раз.
const warned = new Set();

const TarifIcon = ({ name, className = "" }) => {
  const key = String(name || "").trim();
  const Icon = REGISTRY[key];

  if (!Icon) {
    if (key && !warned.has(key)) {
      warned.add(key);
      console.warn("[TarifIcon] unknown icon: " + key);
    }
    return <MdCheckCircle className={className} aria-hidden="true" />;
  }

  return <Icon className={className} aria-hidden="true" />;
};

export const TARIF_ICON_NAMES = Object.keys(REGISTRY);

export default TarifIcon;
